import React, { useRef } from 'react';
var VeltAutocompleteOption = function (props) {
    var userObject = props.userObject, userId = props.userId, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-autocomplete-option", { ref: ref, "user-object": userObject ? (typeof userObject === 'object' ? JSON.stringify(userObject) : userObject) : undefined, "user-id": userId }, children));
};
export default VeltAutocompleteOption;
